import {connect} from 'react-redux';
import {actions} from '../../../js/redux/salesReport';
import ContainerReport from './ContainerReport';

const InventoryReportState = (state) => {
  return {
    ...state.salesReport,
  };
};


const InventoryReportConn =  connect(InventoryReportState, actions)(ContainerReport);
export {
  InventoryReportConn
}